import { Send } from "lucide-react";

export default function TelegramBanner() {
  return (
    <section className="pb-16 md:pb-20 bg-white" data-testid="telegram-banner-section">
      <div className="frida-container">
        <div className="flex items-center gap-5 md:gap-6 bg-[#EAF6FC] border border-[#47BFFF]/25 rounded-3xl p-6 md:p-8">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-[#2FA8E0] flex items-center justify-center shrink-0">
            <Send className="w-6 h-6 md:w-7 md:h-7 text-white" />
          </div>
          <div>
            <h3 className="font-serif text-lg md:text-xl text-[#222222] mb-1">
              Telegram Üzerinden de Buradayız
            </h3>
            <p className="text-sm md:text-base text-[#555555] leading-relaxed">
              Sipariş güncellemelerinden haberdar olmak ve bize hızlıca ulaşmak isterseniz Telegram botumuzu takip edebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
